import { DataProvider, withLifecycleCallbacks } from 'react-admin';
import { lifecycleCallbacks } from './uploadLifecycle';
import { createAccountMethods } from '../supabase/accountService';
import { getIsInitialized, getIdentity } from '../supabase/authProvider';
import { supabase } from '../supabase/supabase';
import { apiDataProvider } from './apiDataProvider';

export const dataProvider = withLifecycleCallbacks(
    {
        ...apiDataProvider,
        ...createAccountMethods(supabase, { getIsInitialized, getIdentity }),
    },
    lifecycleCallbacks
) as DataProvider &
    typeof apiDataProvider &
    ReturnType<typeof createAccountMethods>;

export type CrmDataProvider = typeof dataProvider;
